import { dateParser } from "../../utils/parser";
import { IUserModel, IUserProfessionModel } from "../models/user";
import { IUserRoleModel } from "../models/user";

export const userRoleAdapter = (data: any): IUserRoleModel => {
  if (!data) throw new Error("No data provided to userRoleAdapter");

  const { id, _id, name, access_level } = data;
  const roleId = id || _id;

  if (!roleId || !name || !access_level) throw new Error("Invalid data provided to userRoleAdapter");

  const describeRoleMap = {
    3: "Complete Control and Privileges",
    2: "Partial Control and Management Abilities",
    1: "Limited Access and Basic Functionality",
  };

  const secondaryNameRoleMap = {
    3: "Director",
    2: "Manager",
    1: "User",
  };

  const adaptedRole: IUserRoleModel = {
    id: roleId,
    accessLevel: access_level,
    name: name,
    secondaryName: secondaryNameRoleMap[access_level as keyof typeof secondaryNameRoleMap],
    description: describeRoleMap[access_level as keyof typeof describeRoleMap],
  };

  return adaptedRole;
};

export const userProfessionAdapter = (data: any): IUserProfessionModel => {
  if (!data) throw new Error("No data provided to userProfessionAdapter");

  const { id, _id, name, description, allowedAssets } = data;
  const professionId = id || _id;

  if (!professionId || !name) throw new Error("Invalid data provided to userProfessionAdapter");

  let adaptedAssets: string[] = [];
  if (allowedAssets && allowedAssets.length) {
    adaptedAssets = allowedAssets.map((item: any) => {
      const assetType = item.assetType;
      return assetType?.id || assetType?._id || assetType;
    });
  }

  const adaptedProfession: IUserProfessionModel = {
    id: professionId,
    name,
    description: description || "-",
    assets: adaptedAssets,
  };

  return adaptedProfession;
};

export const userAdapter = (data: any): IUserModel => {
  if (!data) throw new Error("No data provided to userAdapter");

  const { id, _id, email, username, name, lastname, createdAt, role, profession } = data;
  const userId = id || _id;

  if (!userId || !email || !username || !name || !lastname || !createdAt || !role || !profession)
    throw new Error("Invalid data provided to userAdapter");

  const { id: roleIdRaw, _id: roleIdMongo, name: roleName, access_level } = role;
  const roleId = roleIdRaw || roleIdMongo;
  const { id: professionIdRaw, _id: professionIdMongo, name: professionName, description: professionDescription } = profession;
  const professionId = professionIdRaw || professionIdMongo;

  if (!roleId || !roleName || !access_level || !professionId || !professionName)
    throw new Error("Invalid data provided to userAdapter");

  const adaptedRole: IUserRoleModel = userRoleAdapter({
    id: roleId,
    name: roleName,
    access_level: access_level,
  });

  const adaptedProfession: IUserProfessionModel = userProfessionAdapter({
    id: professionId,
    name: professionName,
    description: professionDescription,
  });

  const adaptedUser: IUserModel = {
    id: userId,
    name,
    lastname,
    username,
    email,
    createdAt: dateParser(createdAt),
    avatar: `https://robohash.org/${username}`,
    role: adaptedRole,
    profession: adaptedProfession,
  };

  return adaptedUser;
};
